import React, { useState } from 'react';
import { getApiUrl } from '../config/api';
import { UserIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../context/AuthContext';

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const { login } = useAuth();
  const [step, setStep] = useState(1);
  const [input, setInput] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');

  console.log('LoginModal - isOpen:', isOpen);

  if (!isOpen) return null;

  const handleSendOtp = async () => {
    setError('');
    setInfo('');
    if (!input) {
      setError('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(getApiUrl('/api/auth/send-otp'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: input })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to send OTP');
      setStep(2);
      setInfo('OTP sent! Please check your email ');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setError('');
    setInfo('');
    if (!otp) {
      setError('Please enter the OTP.');
      return;
    }
    setLoading(true);
    try {
      const url = getApiUrl('/api/auth/verify-otp');
      console.log('🔍 Calling verify-otp endpoint:', url);
      console.log('📤 Request payload:', { identifier: input, otp });
      
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: input, otp })
      });
      
      console.log('📥 Response status:', res.status);
      console.log('📥 Response headers:', Object.fromEntries(res.headers.entries()));
      
      const data = await res.json();
      console.log('📥 Response data:', data);
      
      if (!res.ok) throw new Error(data.message || 'OTP verification failed');
      if (data.token && data.user) {
        login(data.token, data.user);
        if (onLoginSuccess) onLoginSuccess(data.token, data.user);
        onClose();
      }
    } catch (err) {
      console.error('❌ Error in handleVerifyOtp:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 transition-all">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-0 relative animate-fade-in">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-pink-600 text-2xl font-bold"
          onClick={() => {
            console.log('LoginModal - close button clicked');
            onClose();
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="flex flex-col items-center pt-8 pb-2 px-8">
          <div className="bg-gradient-to-r from-pink-500 to-indigo-500 rounded-full p-2 mb-2 shadow">
            <UserIcon className="h-8 w-8 text-white" />
          </div>
          <h2 className="text-2xl font-extrabold text-white-700 mb-1 text-center tracking-wide">Login or Signup</h2>
          <div className="flex flex-col items-center w-full mb-4">
            <ul className="text-sm text-gray-600 space-y-1 mb-2">
              <li>🚚 <span className="font-medium">Easily Track Orders, Hassle free Returns</span></li>
              <li>🔔 <span className="font-medium">Get Relevant Alerts and Recommendations</span></li>
              <li>⭐ <span className="font-medium">Wishlist, Reviews, Ratings and more</span></li>
            </ul>
          </div>
        </div>
        <div className="px-8 pb-8">
          {step === 1 && (
            <>
              <label className="block text-gray-700 mb-2 font-semibold">Enter Email Address</label>
              <input
                type="text"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-pink-400 focus:outline-none mb-4 text-base shadow-sm"
                placeholder="Email Address"
                value={input}
                onChange={e => setInput(e.target.value)}
                disabled={loading}
                autoFocus
              />
              <button
                className="w-full py-3 rounded-xl bg-gradient-to-r from-pink-500 to-indigo-500 text-white font-semibold text-lg shadow hover:from-pink-600 hover:to-indigo-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleSendOtp}
                disabled={loading}
              >
                {loading ? 'Sending OTP...' : 'Continue'}
              </button>
            </>
          )}
          {step === 2 && (
            <>
              <label className="block text-gray-700 mb-2 font-semibold">Enter OTP</label>
              <input
                type="text"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-pink-400 focus:outline-none mb-4 text-base shadow-sm"
                placeholder="Enter OTP"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                disabled={loading}
                autoFocus
              />
              <button
                className="w-full py-3 rounded-xl bg-gradient-to-r from-pink-500 to-indigo-500 text-white font-semibold text-lg shadow hover:from-pink-600 hover:to-indigo-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleVerifyOtp}
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Verify & Login'}
              </button>
              <button
                className="w-full mt-2 py-2 rounded-xl border border-pink-400 text-pink-600 font-semibold bg-white hover:bg-pink-50 transition"
                onClick={() => setStep(1)}
                disabled={loading}
              >
                Change Email
              </button>
            </>
          )}
          {error && <div className="mt-4 p-2 bg-red-100 text-red-700 rounded text-center font-medium">{error}</div>}
          {info && <div className="mt-4 p-2 bg-green-100 text-green-700 rounded text-center font-medium">{info}</div>}
        </div>
      </div>
    </div>
  );
};

export default LoginModal; 